/**
 * The countdown starts at 22h 15m 30s from the first visit.
 *
 * The deadline is stored in sessionStorage so reloading the page does not
 * restart the timer (it only starts over in a new session).
 *
 * To close the promotion on a fixed date, set FIXED_DEADLINE to an ISO string.
 */
const FIXED_DEADLINE: string | null = null

const START_MS = (22 * 3600 + 15 * 60 + 30) * 1000
const STORAGE_KEY = 'megapack-ef-360-offer-deadline'

export function getOfferDeadline(): string {
  if (FIXED_DEADLINE) return FIXED_DEADLINE

  const fresh = new Date(Date.now() + START_MS).toISOString()
  if (typeof window === 'undefined') return fresh

  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY)
    if (stored && new Date(stored).getTime() > Date.now()) return stored
    window.sessionStorage.setItem(STORAGE_KEY, fresh)
  } catch {
    // sessionStorage blocked: the countdown simply restarts on reload.
  }

  return fresh
}

/** Percentage of launch places already taken. */
export const spotsTakenPercent = 65
